import React from 'react';
import './User.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faShoppingCart, faUser, faEnvelopeOpen, faGlobe, faPhone, faMap } from '@fortawesome/free-solid-svg-icons';
const User = (props) => {
  const { name, avatar, username, email, salary, website, phone, address } = props.user;
  return (
    <div className='col-4'>
      <article className='user'>
        <div className='user-header'>
          <img src={avatar} alt={name} />
          <h2>{name}</h2>
          <p className='salary'>salay: $ {salary}</p>
        </div>
        <div className='user-body'>
          <ul>
            <li>
              <FontAwesomeIcon icon={faUser} /> Username: {username}
            </li>
            <li>
              <FontAwesomeIcon icon={faEnvelopeOpen} />
              Email: {email}
            </li>
            <li>
              <FontAwesomeIcon icon={faGlobe} /> Website: {website}
            </li>
            <li>
              <FontAwesomeIcon icon={faPhone} />
              Phone: {phone}
            </li>
            <li>
              <FontAwesomeIcon icon={faMap} /> City: {address.city}
            </li>
          </ul>
        </div>
        <div className='user-footer'>
          <button onClick={() => props.handleAddUser(props.user)} className='btn btn-primary'>
            <FontAwesomeIcon icon={faShoppingCart} /> Collect $ {salary}
          </button>
        </div>
      </article>
    </div>
  );
};

export default User;
